import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { NotConfiguredProps } from './types'
import Wrapper from './components/Wrapper'

/**
 * @see {@link NotConfiguredProps}
 * @see {@link Wrapper}
 */
const NotConfigured: React.FC<NotConfiguredProps> = (props) => {
  const eventName = useCIMSNotificationsPanelContext().event.name
  if (props.type === 'Every')
    return <Wrapper ofThe={false}>every {eventName} event, on every</Wrapper>
  const prefix = `${eventName} events where` as const
  if (props.type === '2D') {
    const { groupName, levelName, groupType } = props
    return (
      <Wrapper>
        {prefix} {groupName} is the {groupType} and {levelName} is the
        Concurrence Level
      </Wrapper>
    )
  }
  const { name, type } = props
  return (
    <Wrapper>
      {prefix} {name} is the {type}
    </Wrapper>
  )
}

export default NotConfigured
